module.exports = __webpack_public_path__ + "img/img-f3d111.jpg";